@if (pages.length > 1) {
<ul class="paginator__page-list">
  <li class="paginator__control">
    <button
      mat-icon-button
      [disabled]="currentPage === 0"
      (click)="navigatePreviousPage()"
      aria-label="Eine Seite zurück"
      i18n-aria-label="@@uiElements-paginator-back">
      <mat-icon>arrow_left_alt</mat-icon>
    </button>
  </li>
  @if ((screenSize$ | async) !== 'phone' || useDesktopAppearanceInMobile ) { @if (currentPage > 2) {
  <li class="paginator__page-item">
    <button (click)="firePageChangedEvent(0)">1</button>
  </li>
  } @if (currentPage > 3) {
  <li class="paginator__divider">...</li>
  } @for (page of pages; track identifyPage($index, page)) { @if (isPageVisible(page)) {
  <li class="paginator__page-item" [class.paginator__page-item--active-page]="page === currentPage">
    <button [disabled]="page === currentPage" (click)="firePageChangedEvent(page)">{{ page + 1 }}</button>
  </li>
  } } @if (currentPage < pages.length - 4) {
  <li class="paginator__divider">...</li>
  } @if (currentPage < pages.length - 3) {
  <li class="paginator__page-item">
    <button (click)="firePageChangedEvent(lastPage)">{{ lastPage + 1 }}</button>
  </li>
  } } @else {
  <li class="paginator__page-item paginator__page-item--unfold">
    <button [matMenuTriggerFor]="paginatorMenu" (click)="prepareMobileMenu()">
      {{ currentPage + 1 }}
      <mat-icon>unfold_more</mat-icon>
    </button>
    <mat-menu #paginatorMenu="matMenu" class="paginator-menu" yPosition="above" xPosition="after">
      <button mat-menu-item (click)="mobileMenuUp($event)">
        <mat-icon>arrow_drop_up</mat-icon>
      </button>
      @for (page of mobilePages; track identifyPage($index, page)) {
      <button
        mat-menu-item
        [disabled]="this.currentPage === page"
        [class.mat-menu-item--active-page]="page === currentPage"
        (click)="firePageChangedEvent(page)">
        {{ page + 1 }}
      </button>
      }
      <button mat-menu-item (click)="mobileMenuDown($event)">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </mat-menu>
  </li>
  }
  <li class="paginator__control">
    <button
      mat-icon-button
      [disabled]="currentPage === pages.length - 1"
      (click)="navigateNextPage()"
      aria-label="Eine Seite vorwärts"
      i18n-aria-label="@@uiElements-paginator-forward">
      <mat-icon>arrow_right_alt</mat-icon>
    </button>
  </li>
</ul>
}
